// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20FCH","left":"styles_left__1KJOp"};